'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _somethingWentWrongModal = require('../actions/something-went-wrong-modal');

var _requestAppointmentModal = require('../actions/request-appointment-modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  isOpen: false,
  slotNotAvailable: false
};

var somethingWentWrongModal = function somethingWentWrongModal(state, action) {
  switch (action.type) {
    case _requestAppointmentModal.SUBMIT_REQUEST + '_FAILED':
      if (action.error && action.code === 500) {
        return (0, _assign2.default)({}, { isOpen: true });
      } else if (action.error && action.code === 409) {
        return (0, _assign2.default)({}, { isOpen: true, slotNotAvailable: true });
      }
      return state;
    case _somethingWentWrongModal.OPEN_SOMETHING_WENT_WRONG_MODAL:
      return (0, _assign2.default)({}, { isOpen: true });
    case _somethingWentWrongModal.CLOSE_SOMETHING_WENT_WRONG_MODAL:
      return (0, _assign2.default)({}, { isOpen: false, slotNotAvailable: false });
    default:
      return state || INITIAL_STATE;
  }
};

exports.default = somethingWentWrongModal;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/reducers/something-went-wrong-modal.js